import { clone } from '@jkhy/frontend-utils/functions/object.helpers';
import { Nullable } from '@jkhy/frontend-utils/types';
import { WireFileErrorDto, WireModelDto, WireProcessResultModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { Wire } from './wire.entity';

export const nullWireProcessResult: Nullable<WireProcessResultModelDto> = {
    fileErrors: [] as WireFileErrorDto[],
    wires: [] as WireModelDto[],
};

export class WireFileProcessed extends DomainEntity<Nullable<WireProcessResultModelDto>> {
    constructor(dto = clone(nullWireProcessResult)) {
        super(dto);
    }

    public createDefault(): this {
        return new WireFileProcessed(this.dto) as this;
    }

    public get fileErrors() {
        return this.dto.fileErrors || [];
    }

    public get wires() {
        if (this.dto.wires) {
            return this.dto.wires.map(wireDto => new Wire(wireDto));
        }
        return [];
    }
}
